module.exports = __webpack_public_path__ + "img/Box_empty.34a2bf5b.svg";